import videojs from 'video.js';

videojs.registerComponent('GamesIframe', class extends videojs.getComponent('Component') {
	constructor(player, options) {
		super(player, options);
		this.handleMessage = this.handleMessage.bind(this);
		this.setListeners();
	}

	setListeners() {
		window.addEventListener('message', this.handleMessage);
		this.on('dispose', () => {
			this.options_.onDispose();
			window.removeEventListener('message', this.handleMessage);
		});
	}

	handleMessage(event) {
		const { type, action } = event.data;
		const isClose = type === 'game' && action === 'close';
		if (!isClose) {
			return;
		}
		this.dispose();
	}

	createEl() {
		return videojs.dom.createEl('iframe', {}, {
			src: this.options_.src
		});
	}
});
